import { createSlice } from '@reduxjs/toolkit';
import { TagEntity } from '@interpals/api-web';

import { clearTagSearchResults, searchTags, TAGS_SEARCH_LIMIT, updateUserTags } from 'redux/tags/actions';

export interface InterestTagState {
    tagResults: TagEntity[];
    hasMoreResults: boolean;
    searchTagsIsPending: boolean;
    updateUserTagsIsPending: boolean;
}

const initialState: InterestTagState = {
    tagResults: [],
    hasMoreResults: true,
    searchTagsIsPending: false,
    updateUserTagsIsPending: false,
};

const tagSliceReducer = createSlice({
    name: 'tags',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(searchTags.fulfilled, (state: InterestTagState, { payload }) => {
            state.tagResults = [...state.tagResults, ...payload];
            state.hasMoreResults = payload.length === TAGS_SEARCH_LIMIT;
            state.searchTagsIsPending = false;
        });

        builder.addCase(searchTags.pending, (state: InterestTagState) => {
            state.searchTagsIsPending = true;
        });

        builder.addCase(updateUserTags.pending, (state: InterestTagState) => {
            state.updateUserTagsIsPending = true;
        });

        builder.addCase(clearTagSearchResults, () => initialState);
    },
});

export default tagSliceReducer.reducer;
